// extracted by mini-css-extract-plugin
export default {"omniosLink":"Buttons_omniosLink__IVZKB"};